import XLSX from 'xlsx';

export default function (xlsFile) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 , raw: false, dateNF: 'yyyy-mm-dd'});
      resolve(data);
    };
    reader.readAsBinaryString(xlsFile);
  });
}
